import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import router from './router'
import store from './store'
import './plugins/vuetify-datetime-picker';
import './plugins/vue-croppa';
import useAuth from './useAuth'

Vue.config.productionTip = false


new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
